import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type ToastSpec = {
  id: string;
  header: string;
  content: string;
};

export type UserPrefsToastStatus = 'ok' | 'nok' | 'loading' | undefined

type InitialState = {
  toasts: ToastSpec[];
  userPrefsToastStatus: UserPrefsToastStatus
};

const initialState: InitialState = {
  toasts: [],
  userPrefsToastStatus: undefined,
};

export const globalToastsSlice = createSlice({
  name: 'globalToastsSlice',
  initialState,
  reducers: {
    addToast: (state, { payload: toast }: PayloadAction<ToastSpec>) => {
      state.toasts.push(toast);
    },
    removeToast: (state, { payload: toastId }: PayloadAction<string>) => {
      const position = state.toasts.findIndex(({ id }) => id === toastId);
      if (position === -1) return state;
      state.toasts.splice(position, 1);
    },
    setUserPrefsToastStatus: (state, { payload }: PayloadAction<UserPrefsToastStatus>) => {
      state.userPrefsToastStatus = payload
    }
  },
  selectors: {
    selectToasts: (state) => state.toasts,
    getUserPrefsToastStatus: (state) => state.userPrefsToastStatus,
  },
});

export const { selectToasts, getUserPrefsToastStatus } = globalToastsSlice.selectors;
export const { addToast, removeToast, setUserPrefsToastStatus } = globalToastsSlice.actions;
